module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "register-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "register"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("会员注册")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "status-icon": "",
      "rules": _vm.rules2,
      "label-width": "0"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.ruleForm2.email),
      callback: function($$v) {
        _vm.ruleForm2.email = $$v
      },
      expression: "ruleForm2.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入昵称"
    },
    model: {
      value: (_vm.ruleForm2.name),
      callback: function($$v) {
        _vm.ruleForm2.name = $$v
      },
      expression: "ruleForm2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "contact_address "
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入联系地址"
    },
    model: {
      value: (_vm.ruleForm2.contact_address),
      callback: function($$v) {
        _vm.ruleForm2.contact_address = $$v
      },
      expression: "ruleForm2.contact_address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.ruleForm2.tel),
      callback: function($$v) {
        _vm.ruleForm2.tel = $$v
      },
      expression: "ruleForm2.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "domain"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "团队ID，2-32位英文或数字"
    },
    model: {
      value: (_vm.ruleForm2.domain),
      callback: function($$v) {
        _vm.ruleForm2.domain = $$v
      },
      expression: "ruleForm2.domain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "full_name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "公司名称"
    },
    model: {
      value: (_vm.ruleForm2.full_name),
      callback: function($$v) {
        _vm.ruleForm2.full_name = $$v
      },
      expression: "ruleForm2.full_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "code",
    attrs: {
      "prop": "smscode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "57%",
      "position": "relative",
      "right": "60px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.ruleForm2.smscode),
      callback: function($$v) {
        _vm.ruleForm2.smscode = $$v
      },
      expression: "ruleForm2.smscode"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "35%",
      "height": "35px"
    },
    attrs: {
      "src": _vm.captchaSrc,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "agree"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.ruleForm2.agree),
      callback: function($$v) {
        _vm.ruleForm2.agree = $$v
      },
      expression: "ruleForm2.agree"
    }
  }), _vm._v("\n\t\t\t\t\t我已阅读并同意\n\t\t\t\t\t"), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/user-agreement",
      "target": "_blank"
    }
  }, [_vm._v("用户协议")]), _vm._v("、\n\t\t\t\t\t"), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("隐私政策")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.ruleForm2.agree
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm2')
      }
    }
  }, [_vm._v("注册")])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "login",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v("已有账号？立即登录")])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c86e486"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register.vue
// module id = 562
// module chunks = 4 5 6